(function () {
  'use strict';

  angular
    .module('app')
    .component('itemPaymentProviderDocumentList', itemPaymentProviderDocumentList());

  function itemPaymentProviderDocumentList() {
    return {
      bindings: {
        item: '<',
        type: '@',
        receivedPaymentDocuments: '<',
        company: '<',
      },
      controller: ItemPaymentProviderDocumentListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-provider/item-payment-providers/item-payment-provider-document-list/' +
        'item-payment-provider-document-list.component.html',
    };
  }

  ItemPaymentProviderDocumentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'PaymentProviderService',
  ];

  function ItemPaymentProviderDocumentListComponent(config, UtilService, PaymentProviderService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;

    // Methods
    vm.addItemPaymentProvider = addItemPaymentProvider;
    vm.showItemPaymentProvider = showItemPaymentProvider;
    vm.openSendPaymentRequest = openSendPaymentRequest;

    vm.$onInit = function () {
      // Initializers
      setDocumentIdentifier(vm.type);
      setItemPaymentProvidersPayments();
    };

    function setDocumentIdentifier(type) {
      var documentIdentifier;
      switch (type) {
        case 'bill':
          documentIdentifier = 'bill_id';
          break;
      }

      vm.documentIdentifier = documentIdentifier;
    }

    // Set outstaning balance, based on invoice/booking
    function setItemPaymentProvidersPayments() {
      var balance = 0;
      var totalPrice = vm.item.total_price; // extra prices ??????
      vm.totalAmountReceived = 0;

      vm.paymentProviderDocuments.forEach(function (paymentDocument) {
        paymentDocument.payment_method = vm.UtilService.findItemInArray(
          vm.company.payment_methods,
          'code',
          paymentDocument.payment_provider.payment_method_code
        );

        balance = parseFloat(totalPrice) - parseFloat(paymentDocument.amount);
        totalPrice = balance;

        paymentDocument.balance = balance;

        vm.totalAmountReceived += parseFloat(paymentDocument.amount);
      });

      vm.totalOutstandingBalance =
        parseFloat(vm.item.total_price) - parseFloat(vm.totalAmountReceived);
    }

    function addItemPaymentProvider() {
      var successCallback = function (response) {
        for (var i = 0; i < response.payment_provider_documents.length; i++) {
          var receivedPaymentDocument = response.payment_provider_documents[i];
          if (vm.item.id === receivedPaymentDocument[vm.documentIdentifier]) {
            // invoice_id?
            vm.receivedPaymentDocuments.push({
              id: receivedPaymentDocument.id,
              amount: receivedPaymentDocument.amount,
              payment_provider: {
                id: response.id,
                date: response.date,
                payment_number: response.payment_number,
                notes: response.notes,
                payment_method_code: response.payment_method_code,
                payment_method_id: response.payment_method_id,
                currency: response.currency,
              },
            });

            break;
          }
        }

        vm.UtilService.itemListChanged(response.id);

        setItemPaymentProvidersPayments();
      };

      var payment = {
        currency: vm.item.currency,
        amount: vm.totalOutstandingBalance,
        payment_provider_document: {
          amount:
            vm.totalOutstandingBalance !== undefined
              ? vm.totalOutstandingBalance
              : vm.item.total_price,
          document_id: vm.item.id,
          created_at: vm.item.created_at,
          type: vm.type, // invoice / booking
          number: vm.item.bill_number,
          total_price: vm.item.total_price,
          newBalance:
            vm.totalOutstandingBalance !== undefined
              ? vm.totalOutstandingBalance
              : vm.item.total_price,
          balance:
            vm.totalOutstandingBalance !== undefined
              ? vm.totalOutstandingBalance
              : vm.item.total_price,
          totalBalance:
            vm.totalOutstandingBalance !== undefined
              ? vm.totalOutstandingBalance
              : vm.item.total_price,
        },
      };

      PaymentProviderService.openItemReceivedPaymentModal(
        payment,
        'create',
        vm.company,
        vm.item,
        successCallback
      );
    }

    function showItemPaymentProvider(paymentProviderDocument, mode) {
      var successCallback = function (response) {
        // Update document amount
        paymentProviderDocument.amount = vm.UtilService.findItemInArray(
          response.payment_provider_documents,
          vm.documentIdentifier,
          vm.item.id
        ).amount;

        setItemPaymentProvidersPayments();
      };

      PaymentProviderService.openItemReceivedPaymentModal(
        paymentProviderDocument.payment_provider,
        mode,
        vm.company,
        vm.item,
        successCallback
      );
    }

    function openSendPaymentRequest() {
      // console.log('openSendPaymentRequest');
    }
  }
})();
